import { FormikSelectInputNative } from '@palmetto/palmetto-components';
import { Field, useFormikContext } from 'formik';
import { useEffect, useState } from 'react';

import { FlagPurposeType } from 'types';

export const FlagPurposeSelectionPartial = ({
  purposeOptions,
  disabled,
}: {
  purposeOptions: Array<{ value: string; label: string }>;
  disabled?: boolean;
}) => {
  const [selectedPurpose, setSelectedPurpose] = useState<FlagPurposeType | null>();
  const { values, setFieldValue } = useFormikContext<any>();

  const handlePurposeChange = (value: FlagPurposeType | null) => {
    setFieldValue('purpose', value);
    setSelectedPurpose(value);
  };

  useEffect(() => {
    setSelectedPurpose(values.purpose);
  }, [values.purpose]);

  return (
    <Field
      label="Decision Type"
      name="purpose"
      id="purpose"
      options={purposeOptions}
      component={FormikSelectInputNative}
      autoComplete="off"
      isDisabled={disabled}
      value={selectedPurpose}
      onChange={(event: any) => {
        const selected = event.target.value as FlagPurposeType;
        handlePurposeChange(selected);
      }}
    />
  );
};
